import * as dataTransformersDefinitions from './dataTransformersDefinitions'

export default {
  computed: {
    dataTransformersComputed() {
      const dataTransformers = {}
      for (const key of Object.keys(dataTransformersDefinitions)) {
        dataTransformers[key.toLowerCase()] = this.dataTransformersSetup[key]
      }
      return dataTransformers
    }
  },
  mixins: Object.values(dataTransformersDefinitions),
  mounted() {
    this.setDataTransformers()
  },
  methods: {
    setDataTransformers() {
      this.$store.dispatch('setDataTransformers', this.dataTransformersComputed)
    }
  }
}
